"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvisionDetailsSummaryTable = exports.ReprovisionConfirmationModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const awsui_components_react_1 = require("@amzn/awsui-components-react");
const awsui_collection_hooks_1 = require("@amzn/awsui-collection-hooks");
const react_arb_tools_1 = require("@amzn/react-arb-tools");
const CONSTANTS = __importStar(require("../../common/constants"));
const time_range_selector_1 = require("./time_range_selector");
function getTableAttributeByContentType(contentType) {
    switch (contentType) {
        case 'provision':
            return {
                navRoute: CONSTANTS.ROUTE_STATUS,
            };
        case 'register':
            return {
                navRoute: CONSTANTS.ROUTE_INPUT,
            };
    }
}
function getRedirectLink(navRoute, provisionDetailSummary, isManagedEdgeCompute) {
    if (isManagedEdgeCompute) {
        return `${CONSTANTS.NAV_ROUTE_MANAGED_EDGE_COMPUTE_WAITING_ROOM}/${provisionDetailSummary.authDeviceCode}${navRoute}`;
    }
    else if (navRoute === CONSTANTS.ROUTE_STATUS) {
        return `${CONSTANTS.NAV_ROUTE_PROVISION}/${provisionDetailSummary.processId}/${provisionDetailSummary.nodeId}/${provisionDetailSummary.userName}/${provisionDetailSummary.authDeviceCode}${navRoute}`;
    }
    else {
        return `${CONSTANTS.NAV_ROUTE_PROVISION}/${provisionDetailSummary.processId}/${provisionDetailSummary.nodeId}/${provisionDetailSummary.authDeviceCode}${navRoute}`;
    }
}
const ReprovisionConfirmationModal = (props) => {
    const redirectLink = getRedirectLink(props.navRoute, props.provisionDetails, props.isManagedEdgeCompute);
    return ((0, jsx_runtime_1.jsxs)(awsui_components_react_1.Modal, { onDismiss: props.close, visible: props.visible, closeAriaLabel: "Close modal", footer: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Box, { float: "right", children: (0, jsx_runtime_1.jsxs)(awsui_components_react_1.SpaceBetween, { direction: "horizontal", size: "xs", children: [(0, jsx_runtime_1.jsx)(awsui_components_react_1.Button, { onClick: props.close, variant: "link", children: "Cancel" }), (0, jsx_runtime_1.jsx)(awsui_components_react_1.Button, { href: `${redirectLink}?forceProvision=true`, variant: "primary", children: "Ok" })] }) }), header: "Confirm force provision?", children: ["Are you sure you want to reprovision device with hardware id ", props.provisionDetails.hardwareId, "?"] }));
};
exports.ReprovisionConfirmationModal = ReprovisionConfirmationModal;
const ProvisionDetailsSummaryTable = (props) => {
    const [reprovisionConfirmationModalVisible, setReprovisionConfirmationModalVisible] = react_1.default.useState(false);
    const [selectedItems, setSelectedItems] = react_1.default.useState();
    const { items, actions, filteredItemsCount, collectionProps, filterProps, paginationProps } = (0, awsui_collection_hooks_1.useCollection)(props.provisionDetailSummaries || [], {
        filtering: {},
        pagination: { pageSize: 10 },
        sorting: {},
        selection: {},
    });
    const [localeBundle] = (0, react_arb_tools_1.useBundle)(CONSTANTS.STRINGS_NAMESPACE);
    const tableAttribute = getTableAttributeByContentType(props.contentType);
    const confirmReprovisionPopup = (provisionDetailSummary) => (e) => {
        if (provisionDetailSummary.isReprovision == 'True' && props.contentType == 'register') {
            e.preventDefault();
            setReprovisionConfirmationModalVisible(true);
            setSelectedItems([provisionDetailSummary]);
        }
    };
    const columnDefinitions = [];
    columnDefinitions.push({
        id: 'hardware Id',
        header: 'Hardware ID',
        cell: (e) => ((0, jsx_runtime_1.jsx)(awsui_components_react_1.Link, { href: getRedirectLink(tableAttribute.navRoute, e, props.isManagedEdgeCompute), onFollow: confirmReprovisionPopup(e), children: e.hardwareId })),
    }, {
        id: `${props.contentType} Time`,
        header: 'Provision Start Date',
        cell: (e) => e.provisionStartDate.toString(),
        sortingField: 'provisionStartDate',
    });
    if (!props.isManagedEdgeCompute) {
        columnDefinitions.push({
            id: 'process id',
            header: 'Process ID',
            cell: (e) => e.processId,
        }, {
            id: 'node id',
            header: 'Node ID',
            cell: (e) => e.nodeId,
        });
    }
    if (props.contentType === 'provision') {
        columnDefinitions.push({
            id: 'username',
            header: 'Provision By',
            cell: (e) => e.userName,
        });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(exports.ReprovisionConfirmationModal, { isManagedEdgeCompute: props.isManagedEdgeCompute, visible: reprovisionConfirmationModalVisible, navRoute: tableAttribute.navRoute, provisionDetails: selectedItems ? selectedItems[0] : {}, close: () => setReprovisionConfirmationModalVisible(false) }), (0, jsx_runtime_1.jsx)(awsui_components_react_1.Table, { filter: (0, jsx_runtime_1.jsx)("div", { className: "filter-container", children: props.timeRangeSelectorProps ? ((0, jsx_runtime_1.jsx)(time_range_selector_1.TimeRangeSelector, { rangeValue: props.timeRangeSelectorProps.timeRangeValue, onRangeValueChange: props.timeRangeSelectorProps.onTimeRangeValueChange })) : ((0, jsx_runtime_1.jsx)("div", {})) }), loadingText: localeBundle !== undefined ? localeBundle.getMessage('loading') : 'loading', loading: !props.provisionDetailSummaries, items: items, columnDefinitions: columnDefinitions, selectionType: "single", selectedItems: selectedItems, onSelectionChange: ({ detail }) => setSelectedItems(detail.selectedItems), empty: (0, jsx_runtime_1.jsxs)(awsui_components_react_1.Box, { textAlign: "center", color: "inherit", children: [(0, jsx_runtime_1.jsx)("b", { children: localeBundle !== undefined ? localeBundle.getMessage('no-record') : 'No record' }), (0, jsx_runtime_1.jsx)(awsui_components_react_1.Box, { padding: { bottom: 's' }, variant: "p", color: "inherit", children: localeBundle !== undefined
                                ? localeBundle.getMessage('no-record-found')
                                : 'No record found' })] }), pagination: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Pagination, { ...paginationProps, ariaLabels: {
                        nextPageLabel: 'Next page',
                        previousPageLabel: 'Previous page',
                        pageLabel: (pageNumber) => `${pageNumber}`,
                    } }) })] }));
};
exports.ProvisionDetailsSummaryTable = ProvisionDetailsSummaryTable;
